export enum Source {
  Drip  = 1,
  Crm   = 2,
}
export enum Type {
  Email  = 1,
  Mobile   = 2,
}

export class GeetestValidate {
  public challenge?: string;
  public validate?: string;
  public seccode?: string;
}

export enum LoginCode {
  Ok = 0,
  CodeError = 1001,
  UserNotExist = 1002,
  PasswordError = 1003,
  LoginTypeNotSupport = 1004,
  NeedCode = 1005,
  UnKnown = 1010
}

export enum AuthStatusCode {
  Ok = 0,
  BindByOther = 1200,
  AuthRefresh = 1201,
  Error = -1
}
